import ANALYTICS_ACTIONS from "../actionTypes/analytics";

export const setAnayticsTags = payload => ({ type: ANALYTICS_ACTIONS.SET_ANALYTICS_CHART_TAGS, payload });
export const setAnlyticsTagLoading = payload => ({ type: ANALYTICS_ACTIONS.SET_ANALYTICS_CHART_TAG_DATA_LOADING, payload });
export const updateAnalyticsDuration = payload => ({ type: ANALYTICS_ACTIONS.UPDATE_ANALYTICS_CHART_DURATION, payload });
export const setPlotData = payload => ({ type: ANALYTICS_ACTIONS.SET_ANALYTICS_PLOT_DATA, payload });
export const setAlarmsHistory = payload => ({ type: ANALYTICS_ACTIONS.SET_ALARMS_HISTORY, payload });
export const updateAnalyticsAlarms = payload => ({ type: ANALYTICS_ACTIONS.UPDATE_ANALYTICS_ALARMS, payload });
export const saveAnalyticsAlarms = payload => ({ type: ANALYTICS_ACTIONS.SAVE_ANALYTICS_ALARMS, payload });
export const setAnalyticsCurrentView = payload => ({ type: ANALYTICS_ACTIONS.SET_ANALYTICS_CURRENT_EDITVIEW, payload });
export const resetAnalyticsData = () => ({ type: ANALYTICS_ACTIONS.RESET_ANALYTICS_CHART_DATA });
export const resetSpikeLine = payload => ({type:ANALYTICS_ACTIONS.RESET_SPIKE_LINE,payload})
export default {
  setAnayticsTags,
  updateAnalyticsDuration,
  setAnlyticsTagLoading,
  setPlotData,
  setAlarmsHistory,
  saveAnalyticsAlarms,
  setAnalyticsCurrentView,
  resetAnalyticsData,
  resetSpikeLine
};
